document.addEventListener('DOMContentLoaded', () => {
  const csrfMeta = document.querySelector('meta[name="csrf-token"]');
  const csrfInputs = document.querySelectorAll('input[name="_token"]');

  if (!csrfMeta && !csrfInputs.length) return;

  let lastRefresh = Date.now();
  let refreshInProgress = false;
  const MINUTE = 60 * 1000;
  const STALE_INTERVAL = 60 * MINUTE;
  const REFRESH_INTERVAL = 5 * MINUTE;

  function refreshCsrf() {
    if (Date.now() - lastRefresh < STALE_INTERVAL) return;
    if (refreshInProgress) return;
    refreshInProgress = true;

    fetch('/refresh-csrf')
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => {
        if (data && data.csrf) {
          csrfMeta?.setAttribute('content', data.csrf);
          csrfInputs?.forEach(input => input.value = data.csrf);
          lastRefresh = Date.now();
        } else {
          console.warn("CSRF refresh failed: Invalid response format");
        }
      })
      .catch((error) => {
        console.error("CSRF refresh failed: ", error);
      })
      .finally(() => {
        refreshInProgress = false;
      });
  }

  window.addEventListener('focus', refreshCsrf);
  setInterval(refreshCsrf, REFRESH_INTERVAL);

  // Handle bfcache restoration
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      lastRefresh = 0;
      refreshCsrf();
    }
  });
});
